<template>
  <div class="event-type-badge">
    <span>{{ eventTypeName }}</span>
    <span
      class="glyphicon glyphicon-remove"
      @click="removeEventType"
      @keydown.space="removeEventType"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  eventTypeName: string;
}>();

const emit = defineEmits(["remove-event-type"]);

function removeEventType(): void {
  emit("remove-event-type");
}
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables";

@media (max-width: @screen-lg-desktop) {
  .event-type-badge {
    text-align: center;
  }
}

.event-type-badge {
  background: #f4f5fa;
  padding: 0.5rem 1rem;
  border: #8f8f8f 1px solid;
  border-radius: 25px;
  font-size: 1.2rem;

  .glyphicon.glyphicon-remove {
    padding: 5px 10px;
    font-size: 1rem;
    cursor: pointer;
  }
}
</style>
